import Vue from "vue";
import Router from "vue-router";
import { getLogin } from "../utils/api";
import store from "../store/index.js";
import routes from "@/router/routers"
import { Message } from 'element-ui';
import err from "../views/404/404.vue";
import Login from "../views/login/login.vue";
Vue.use(Router);
let router = new Router({ routes, mode: 'history', });

// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  // 获得openido
  const hasUserOpenid = localStorage.getItem("userOpenid")
  // const hasUserOpenid = "oOW8d5JJbg3YMsNAs49JiRyiZvYk"
  

  // 是否登陆
  if (hasUserOpenid) {
    // console.log("已登陆");
    // 登陆后显示头像名字
    store.state.headimgurl = localStorage.getItem("headimgurl");
    store.state.nickname = localStorage.getItem("nickname");
    store.state.userOpenid = hasUserOpenid;
    next();
  } else {
    // console.log("没有登陆", url);
    let url = window.location.href;
    if (url.indexOf("code=") != -1) {
      let code = url.split("?")[1];
      getLogin(code)
        .then(res => {
          if (res.code == 200) {
            console.log(res)
              localStorage.setItem("phoneBindState", res.data.phoneBindState);
              localStorage.setItem("userOpenid", res.data.userOpenid);
              localStorage.setItem("nickname", res.data.userInfo.nickname);
              localStorage.setItem(
                "headimgurl",
                res.data.userInfo.headimgurl
              );
              // 登陆后显示头像名字
              store.state.headimgurl = res.data.userInfo.headimgurl;
              store.state.nickname = res.data.userInfo.nickname;
              store.state.userOpenid = res.data.userInfo.userOpenid;
              // url = url.split("?")[0];
              // console.log("你好呀啊啊啊啊啊啊hahha")
              // window.history.pushState({}, '', url);
            next();
          } else {
            next({ path: '/index' })
          }
        })
        .catch(err => {
          console.log("未注册");
          url = url.split("/index")[0];
          window.history.pushState({}, '', url);
          next(false);
        });
    } else {
      // Message({
      //   message: '请先登录!',
      //   type: 'warning'
      // });
      // console.log()
      if (to.path == "/index") {
        next();
      } else {
        next({ path: '/index', query: { redirect: to.fullPath } })
      }
    }
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js